import React, { useState, useContext, useEffect } from 'react'
import { Input, Modal, Form, Checkbox, Row, Col, Button, Select } from 'antd'
import { displayMessage } from '../../helpers/messages'
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { ERegExp } from '../../enums/ERegExp'
import { areArraysEqual } from '@mui/base'

const { Option } = Select

export default function CreateClient({ handleOnCloseModal }) {
    const [form] = Form.useForm()
    const [usersList, setUsersList] = useState([])
    const [clientsList, setclientsList] = useState([])

    const {
        setShowLoading,
        mobile_mode,
    } = useContext(GeneralContext)

    const handleCreateClient = async (values) => {
        setShowLoading(true)

        try {
            const formatedUsers = values?.users?.length > 0 ?
                values.users.map(user => parseInt(user.split('|')[0]))
                :
                []
            const formatedClients = values?.clients?.length > 0 ?
                values.clients.map(user => parseInt(user.split('|')[0]))
                :
                []
            // if (formatedUsers.length <= 0 && formatedClients.length <= 0) {
            //     alert(displayMessage('NOTIFICATION_NO_USER_OR_CLIENT_WARNING'))
            // }
            // else {
                const body = { users: formatedUsers, title: values.title, description: values.description }
                await api.notifications.create(body)
                await handleOnCloseModal(true)
                alert(displayMessage('CREATE_NOTIFICATION_SUCCESS'), 'success', displayMessage('SUCCESS'))
            // }
        } finally {
            setShowLoading(false)
        }
    }

    useEffect(() => {
        loadLists()
    }, [])

    async function loadLists() {
        const tempUsersList = await api.user.list()
        const tempClientList = await api.user.list()
        setUsersList(tempUsersList.data)
        setclientsList(tempClientList.data)
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900">{displayMessage('REGISTER_NOTIFICATION')}</div>}
            open={true}
            onCancel={() => handleOnCloseModal(false)}
            centered={true}
            footer={
                <div className='flex flex-col justify-end ss:flex-row gap-2'>
                    <SL_Button className="w-full ss:w-[150px] bg-gray-500 border-transparent" onClick={() => handleOnCloseModal(false)}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-full ss:w-[150px] m-0" onClick={() => form.submit()}>{displayMessage('END_REGISTER')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={650}
            bodyStyle={{ overflow: 'auto', maxHeight: 300 }}
        >
            <Form
                onFinish={handleCreateClient}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 10 }}>
                    <Form.Item
                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('TITLE')}:</span>}
                        name="title"
                        className={`w-full m-0`}
                        rules={[
                            { required: true, message: displayMessage('TITLE_MANDATORY') },
                            { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                        ]}
                    >
                        <Input type="text" className='text-fit-red-900' style={{ flex: 1 }} />
                    </Form.Item>

                    <Form.Item
                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('MESSAGE')}:</span>}
                        name="description"
                        className={`w-full m-0`}
                        rules={[
                            { required: true, message: displayMessage('MESSAGE_DOCUMENT_MANDATORY') },
                            { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                        ]}
                    >
                        <Input type="text" className='text-fit-red-900' />
                    </Form.Item>

                    <Form.Item
                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('USERS')}:</span>}
                        name="users"
                        className={`w-full m-0`}
                    // rules={[
                    //     { required: true, message: displayMessage('USER_MANDATORY') },
                    // ]}
                    >
                        <Select className='w-full' mode="multiple" >
                            {usersList.map(user => <Option key={user.id} value={`${user.id}|${user.full_name}`}>{`${user.full_name}`}</Option>)}
                        </Select>
                    </Form.Item>
                </div>
            </Form>
        </Modal >
    )
}